'use client';

import { useEffect } from 'react';
import { useStore } from '@/store/store';
import type { RewardMachineExitScreenData, RewardMachineInfoScreenData } from '@/lib/reward-machine-data';
import type { PlayDay } from '@/types/reward-machine';

/** Partial of both screen data types so info page, exit page, and banner can pass their props. */
export type RewardMachineWelcomeModalData = Partial<
    Omit<RewardMachineExitScreenData & RewardMachineInfoScreenData, 'todayStatus'>
> & { todayStatus?: number | PlayDay };

export const useSyncRewardMachineWelcomeModalData = (data: RewardMachineWelcomeModalData): void => {
    const setWelcomeModalData = useStore((s) => s.rewardMachine.welcomeModal.setWelcomeModalData);
    const {
        serverTime,
        loggedIn,
        user,
        entryData,
        product,
        features,
        rewardsMachineContent,
        error,
        todayStatus,
        bonusSpinsZone,
        recommendedGamesZone,
        bonusDraw,
        isBonusDraw,
        locale,
        isRewardsMachineEnabled,
        isBonusSpinsEnabled,
        brand,
        termsAndConditions,
        region
    } = data;

    useEffect(() => {
        setWelcomeModalData({
            bonusDraw,
            bonusSpinsZone,
            brand,
            entryData,
            error,
            features,
            isBonusDraw,
            isBonusSpinsEnabled,
            isRewardsMachineEnabled,
            locale,
            loggedIn,
            product,
            recommendedGamesZone,
            region,
            rewardsMachineContent,
            serverTime,
            termsAndConditions,
            todayStatus,
            user
        });
    }, [
        setWelcomeModalData,
        serverTime,
        loggedIn,
        user,
        entryData,
        product,
        features,
        rewardsMachineContent,
        error,
        todayStatus,
        bonusSpinsZone,
        recommendedGamesZone,
        bonusDraw,
        isBonusDraw,
        locale,
        isRewardsMachineEnabled,
        isBonusSpinsEnabled,
        brand,
        termsAndConditions,
        region
    ]);
};
